import { Component, OnInit } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'app-navbar-panel',
  standalone: true,
  imports: [MatIconModule], 
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.scss'],
})
export class NavbarPanelComponent  implements OnInit {

  public userName: string = '';

  constructor() { }

  ngOnInit() {
    this.userName = localStorage.getItem('name') ?? '';
  }

}
